"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import Cookies from "js-cookie";
const COOKIE_DOMAIN = process.env.NODE_ENV !== "development" ? ".aicoalesce.com" : undefined;
export function useClientTz() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
}
function _temp() {
  const deviceTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!deviceTz || Cookies.get("client-tz") === deviceTz) {
    return;
  }
  Cookies.set("client-tz", deviceTz, {
    domain: COOKIE_DOMAIN,
    path: "/",
    expires: 365,
    secure: typeof COOKIE_DOMAIN !== "undefined",
    sameSite: "lax"
  });
}